import styled, { keyframes } from "styled-components";
import { paletas } from "../../../../styles/theme";

const animacao = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  animation: 0.3s ${animacao};

  @media (min-width: 960px) {
    margin-left: 20px;
  }
`;

export const TituloRank = styled.h3`
  color: ${paletas.White};
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px;
  margin: 0 2px -10px;
`;

export const TabelaRank = styled.table`
  width: 100%;
  font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
  color: ${paletas.White};
  margin-top: 10px;

  .container-tabela {
    width: 100%;
    max-height: 300px;
    overflow-y: scroll;
  }

  td,
  th {
    text-align: right;
    padding: 8px;
  }

  th {
    background-color: ${paletas.Grafite75};
    svg {
      float: left;
    }
  }

  tr {
    background-color: ${paletas.Grafite25};
  }
  tr:nth-child(1) {
    background-color: rgba(255, 215, 0, 0.3);
  }
  tr:nth-child(2) {
    background-color: rgba(192, 192, 192, 0.3);
  }
  tr:nth-child(3) {
    background-color: rgba(205, 127, 50, 0.3);
  }
`;
